import React from 'react';
import TablaVotosPartidos_FilaCandidato from './TablaVotosPartidos_FilaCandidato';
import TablaVotosPartidos_FilaPartidoCurules from './TablaVotosPartidos_FilaPartidoCurules';
import styled from 'styled-components/macro';
import { fmt } from '../../utils/fmtUtils';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import Logo from '../../containers/Logo';

const TablaVotosPartidos_FilaPartido = ({ partido, eleccion, mostrarCandidatos, mostrarCargos,
  mostrarSoloCandidatosConCargo }) => {
  // const nomenclator = useNomenclator();
  // const elecOptions = useEleccion();
  // const {mostrarCargos, mostrarCandidatos} = elecOptions.tableOptions;
  const nomenclator = useNomenclator();
  const par = nomenclator.partidos[Number(partido.act.codpar) - 1];
  const nompar = (par === undefined) ? "" : par.nombre;
  const Span = mostrarCargos ? 1 : 2;

  return (
    <>
      <tr className="partido">
        <td colSpan={Span}>
          <PartidoLogoNombreContainer>
            <StyledLogo codpar={par.codpar} height={'50px'} width={'50px'} />
            <span style={{ paddingLeft: '10px' }}>{nompar}</span>
          </PartidoLogoNombreContainer>
        </td>
        <PartidoNumeros className="votes margin">{fmt(partido.act.vot)}</PartidoNumeros>
        <PartidoNumeros className="percent">{partido.act.pvot}</PartidoNumeros>
        {mostrarCargos && <TablaVotosPartidos_FilaPartidoCurules data={partido} />}
      </tr>
      {mostrarCandidatos && partido.act.cantotabla?.map((x,index) => {
        if (!mostrarSoloCandidatosConCargo || (mostrarSoloCandidatosConCargo && x.carg === '1')) {
          return (<TablaVotosPartidos_FilaCandidato data={x} key={index} eleccion={eleccion} mostrarCargos={mostrarCargos} />)
        }
      })}
    </>
  );
};

const StyledLogo = styled(Logo)`
  padding: 5px;
  /* left: 5px;
  top: 5px; */
  /* height: 50px; */
  /* height: ${({ height }) => height}; */
  width: ${({ width }) => width}; 
`;


export const PartidoLogoNombreContainer = styled.div`
  display:flex;
  align-items: center;
  gap:10px;
`;

export const PartidoNumeros = styled.td`
  font-weight: 400;
`;


export default TablaVotosPartidos_FilaPartido;
